export function makeid(length: number)
{
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++)
    {
        const byte = new Uint8Array(1);
        crypto.getRandomValues(byte);
        const index = byte[0] % characters.length;
        result += characters.charAt(index);
    }
    return result;
}